import { useState } from 'react';
import type { FAQItem } from '@/mocks/faq';

interface FAQSectionProps {
  items: FAQItem[];
}

export default function FAQSection({ items }: FAQSectionProps) {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="space-y-3">
        {items.map((item) => (
          <div
            key={item.id}
            className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
          >
            <button
              onClick={() => toggle(item.id)}
              className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
            >
              <span className="font-heading text-base font-semibold text-foreground-900 pr-4">
                {item.question}
              </span>
              <span className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                openId === item.id
                  ? 'bg-primary-500 text-background-50 rotate-180'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                <i className="ri-arrow-down-s-line text-sm"></i>
              </span>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                openId === item.id ? 'max-h-96 pb-4' : 'max-h-0'
              }`}
            >
              <p className="px-5 text-sm text-foreground-700 leading-relaxed">
                {item.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}